import { useEffect, useState } from 'react';
import { useLocation,Redirect, Route } from 'react-router-dom';


import { makeStyles } from '@material-ui/core/styles';
// import { Link } from 'react-router-dom';

// components
import Grid from '@material-ui/core/Grid';
import Typography from 'components/shared/Typography';
import { Container } from '@mui/material';
import { SPACING_THIRD, SPACING, SPACING_HALF } from 'constants/spacing';

// hooks
// import { useAllEvents, useCreateEvent, useUpdateEvent } from 'hooks/event';
// import { useDivisionValue } from 'providers/DivisionProvider';
import { useValidatePayment } from 'hooks/payment';
import SuccessfulPayment from './SuccessfulPayment';
import FailedPayment from './FailedPayment';



// utils
// import { arrayUniqueKey } from 'utils';

//assets
import orderSummaryImage from 'assets/images/customer/orderSummary.png';
import Input from 'components/shared/Input';


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    // minHeight: '100vh',
    minHeight: 'fit-content',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  leftPanel: {
    width: '100%',
    // minHeight: '100vh',
    minHeight: 'fit-content',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  form: {
    width: '100%',
  },
  buttonWraper: {
    marginTop: theme.spacing(SPACING),
  },
  monkey: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  phoneInput: {
    '& .MuiInputBase-input::placeholder': {
      textAlign: 'center',
    },
    '& .MuiInputBase-input': {
      textAlign: 'right',
      direction: 'rtl',
    },
  },
  largeLabel: {
    marginTop: 35,
    fontSize: theme.typography.pxToRem(25),
    height: '75%',
    '&:disabled':{
      color: '#959595'
    }
  },
  wholepage: {
    // width: '100vw',
    // height: '100vh',
    // backgroundColor: '#e5e5e5',
  },
  mainContainer: {
    // backgroundColor: '#f5f5f5',
    // borderRadius:"10px",
    position: 'relative',
    top: 'calc((100% - 650px) /2)',
    padding: '0px',
    height:"650px",

    [theme.breakpoints.down('xs')]: {
      // backgroundColor: '#e5e5e5',
      top: '0',
    },
  },
  branchCard: {
    borderWidth: '3px',
    borderStyle: 'solid',
    borderColor: '#D2D2D2',
    borderRadius: '20px',

    [theme.breakpoints.down('xs')]: {
      // marginBottom:"10px",
      margin: '3%',
    },
  },
  branchCardSelected: {
    borderWidth: '3px',
    borderStyle: 'solid',
    borderColor: '#24AF6E',
    backgroundColor: '#f1f7f5',
    borderRadius: '20px',

    [theme.breakpoints.down('xs')]: {
      // marginBottom:"10px",
      margin: '3%',
    },
  },
}));



function PaymentCallback({ selectedBranch, selectedService, selectedTime, nextStep, prevStep }) {

  const classes = useStyles();

  const {mutate, isLoading} = useValidatePayment()
  const [paymentStatus, setPaymentStatus] = useState("")
  const [approvedEvent,setApprovedEvent] = useState("")
  const [approvedPayment, setApprovedPayment] = useState("")
  const [responseCode, setResponseCode] = useState(100)

  const location = useLocation();

  useEffect(()=>{
    const searchParams = new URLSearchParams(location.search);
    if(!searchParams) return;
    let authority = searchParams.get("Authority")
    mutate({authority},{
      onSuccess: (data) => {
        console.log('OK_payment', data);
        if (data?.status === 'OK') {
          setPaymentStatus("OK")
          setApprovedEvent(data?.event)
          setApprovedPayment(data?.payment)
        }else{
          setPaymentStatus("NOK")
          setResponseCode(data?.responseCode)
        }
      },
    })

  },[mutate,location])


  const dateOptions = {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  };

  const onSubmitNext = (e) => {
    console.log(selectedService)
    console.log(selectedTime)
    console.log(selectedTime.startDate.getTime())
    console.log(selectedTime.endDate.getTime())
    console.log('nwx!1:', e);
    nextStep();
  };

  const onSubmitPrev = (e) => {
    console.log('back!!!:', e);
    prevStep();
  };
  console.log('selectedService', selectedService);
  return(
    <div className={classes.wholepage}>
      <Container maxWidth="md"  className={classes.mainContainer}>
      {paymentStatus ==="OK" && <SuccessfulPayment event={approvedEvent} payment={approvedPayment}/>}
      {paymentStatus ==="NOK" && <FailedPayment responseCode={responseCode} />}

    </Container>
    </div>
  )
}

export default PaymentCallback;
